import { CountryCode } from '@/types'

export const transitionEasing = [0.25, 0.625, 0.01, 0.98]
export const transitionEasingReverse = [0.98, 0.01, 0.75, 0.75]

export const countryCodes: CountryCode[] = [
  { acronym: 'GB', code: '+44', digits: '44' },
  { acronym: 'US', code: '+1', digits: '1' },
]

export const mobileDevices = [
  'Apple (iPhone 15 Pro)',
  'Apple (iPhone 15)',
  'Apple (iPhone 14 Pro)',
  'Apple (iPhone 14)',
  'Apple (iPhone 13 Mini)',
  'Apple (iPhone 13)',
  'Apple (iPhone 12)',
  'Apple (iPhone X)',
  'Samsung (Galaxy S24 Ultra)',
  'Google (Pixel 8 Pro)',
  'Google (Pixel 7a)',
  'OnePlus (9 Pro)',
  'OnePlus (12)',
  'Motorola (Razr+ 2023)',
  'Samsung (Galaxy A14)',
]

export const ticketingIssues = [
  'Unable to log in to my account',
  'Payment processing issues',
  'Website or app loading slowly',
  'Incorrect information on my tickets',
  'Lost or stolen tickets',
  'Event cancellation or rescheduling inquiries',
  'Trouble accessing the seating chart',
  'Refund request',
  'Technical glitches during the ticket purchase process',
  'Issues with mobile ticketing or QR code scanning',
  'Difficulty updating account information',
  'VIP or special requests not fulfilled',
  'Inquiries about event details or policies',
  'Accessibility concerns for differently-abled attendees',
  'Complaints about customer service interactions',
]
